import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/vue-query";
import { MePreferencesApi } from "mws-ts-v2-sdk";

import { getUniversalAxios } from "~/utils/axios/getUniversalAxios";

const getPreferencesApi = () => {
  return new MePreferencesApi(
    undefined,
    useRuntimeConfig().public.catalogServiceUrl,
    getUniversalAxios(),
  );
};

export const preferencesQueryKeys = createQueryKeys("preferences", {
  list: () => ({
    queryKey: ["list"],
    queryFn: async () => {
      const response = await getPreferencesApi().getFollowedPreferences();

      return response.data;
    },
  }),
});

export const useUserPreferencesQuery = () => {
  const { isLoggedIn } = useAuth();

  return useQuery({
    ...preferencesQueryKeys.list(),
    enabled: isLoggedIn,
    // Never refetch this, unless the user does this themselves
    staleTime: Infinity,
  });
};
